import * as React from 'react';
import TwoColRow from './TwoColRow';
const SeizureAttemptsSummary = ({ value, i18n, formatDate }) => (React.createElement(React.Fragment, null,
    React.createElement(TwoColRow, { label: i18n('controlpoint.numberOfSeizureAttempts'), value: value.quantity }),
    React.createElement(TwoColRow, { label: i18n('common.verifiedwith'), value: `${i18n('readreport.informationsource.SeizureAttempts')} (${formatDate(value.verificationDate)})` })));
export default SeizureAttemptsSummary;
